import { Dialog } from '@mui/material';
import TitleWithSubtopicIcon from './TitleWithSubtopicIcon';
import LevelDialogContent from './LevelDialogContent';
import InnerContentWrapper from './InnerContentWrapper';
import LevelWrapper from './LevelWrapper';
import React from 'react';

export type LevelDialogProps = {
  open: boolean;
  onClose: () => void;
  editor?: boolean;
  children: React.ReactNode;
};

const LevelDialog = ({
  open,
  onClose,
  editor,
  children,
  ...props
}: LevelDialogProps) => (
  <Dialog
    open={open}
    onClose={(_, reason) => {
      if (editor && ['escapeKeyDown', 'backdropClick'].includes(reason)) {
        return;
      }

      onClose();
    }}
    slotProps={{
      paper: {
        style: {
          marginLeft: 15,
          marginRight: 15,
          width: '100%',
          maxWidth: '100%',
        },
      },
    }}
    maxWidth={false}
    fullWidth
    {...props}
  >
    {children}
  </Dialog>
);

LevelDialog.Title = TitleWithSubtopicIcon;
LevelDialog.Content = LevelDialogContent;
LevelDialog.InnerContentWrapper = InnerContentWrapper;
LevelDialog.LevelWrapper = LevelWrapper;

export default LevelDialog;
